import { z } from "zod";

export const HolidayFieldsSchema = z.object({
  id: z.number(),
  holiday: z.string(),
});
export const PartialHolidayFieldsSchema = HolidayFieldsSchema.deepPartial();

export type HolidayFields = z.infer<typeof HolidayFieldsSchema>;
export type PartialHolidayFields = z.infer<typeof PartialHolidayFieldsSchema>;
export type Holiday = z.infer<typeof HolidayFieldsSchema>;
